import { render } from "./GbCustomer.vue?vue&type=template&id=ef6938e0&scoped=true"
import script from "./GbCustomer.vue?vue&type=script&lang=js"
export * from "./GbCustomer.vue?vue&type=script&lang=js"

import "./GbCustomer.vue?vue&type=style&index=0&id=ef6938e0&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6938e0"]])

export default __exports__